import { useCallback, useState } from 'react'

import { AuthByUsernameProps } from 'src/services/api/auth'
import { useAuthContext } from 'src/contexts/auth'

export default function (): {
  authByUsername: (data: AuthByUsernameProps) => Promise<void>
  error: string
  loading: boolean
} {
  const authContext = useAuthContext()

  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const authByUsername = useCallback(
    async (data: AuthByUsernameProps) => {
      setError('')
      setLoading(true)

      const response = await authContext.authByUsername(data)

      setLoading(false)

      if (response.error) {
        setError(response.error)
      }
    },
    [authContext]
  )

  return { authByUsername, error, loading }
}
